import FormatCurrency from './FormatCurrency';

export const FREE_LABEL = 'Grátis';

/**
 * Preço para exibição em listagens. Projetos gratuitos passaram a conviver com
 * os pagos na mesma listagem, então "R$0,00" vira "Grátis" em um lugar só.
 */
export default value => {
  if (value === null || value === undefined) {
    return null;
  }

  return Number(value) === 0 ? FREE_LABEL : FormatCurrency(value);
};

export const isFreePrice = value =>
  value !== null && value !== undefined && Number(value) === 0;
